import React, { useState } from "react";
import { ReactComponent as Close } from "../../../assets/images/close.svg";
import moment from "moment";
import { CSVLink } from "react-csv";
import Loader from "../../shared/Loader/Loader";

interface IStatusTabProps {
    statusData: any;
    setStatusData: (val: Array<object>) => any;
    compLoader: boolean;
}

export default function StatusTab(props: IStatusTabProps) {
    const [searchText, setSearchText] = useState('')

    const handleSearch = (text: string) => {
        setSearchText(text);
        //setSearchText(text);
        let data = [];
        data = props.statusData.filter(
            (el: any) => {
                if (text === "") {
                    return el
                }
                else {
                    return el.postedFullName.includes(text) || el.noteType.includes(text);
                }
            }
        )
        props.setStatusData(data);
    }
    return (
        <div className="rr-list-wrapper">
            {props.compLoader && <Loader showComponentLoader={true} />}
            <div className="rr-list-heading d-flex align-items-center justify-content-between">
                <h3 className="heading-sub">
                    <div className="table-search">
                        <input
                            className="table-search-field table-search-icon"
                            placeholder="Search"
                            onChange={(e) => handleSearch(e.target.value)}
                            value={searchText}
                        ></input>
                        {/* eslint-disable-next-line */}
                        <a href="javascript:void(0)" className="table-search-close">
                            <Close />
                        </a>
                    </div>
                </h3>

                <div className="rr-list-btns">
                    <button className="btn btn-primary">
                        <span className="send-excel"></span>
                        <CSVLink data={props.statusData}> Export to CSV</CSVLink>
                    </button>
                </div>
            </div>
            <div className="rr-list-content">
                <div className="r-table-wrapper">
                    {props.statusData.length ? <table className="table">
                        <thead>
                            <tr>
                                <th>Notes Entered By</th>
                                <th>Notes Source</th>
                                <th>Notes Type</th>
                                <th>Updated Date</th>
                                <th>Notes</th>
                            </tr>
                        </thead>
                        <tbody>

                            {props.statusData.map((field: any) => (
                                <tr>
                                    <td>{field.postedFullName}</td>
                                    <td>{field.noteSource}</td>
                                    <td>
                                        <span className={`setup-label label-${field.noteType}`}>{field.noteType}</span>
                                    </td>
                                    <td> {moment(field.updatedAt).format('YYYY-MM-DD HH:mm:ss')}</td>
                                    <td>{field.notes}</td>
                                </tr>

                            ))}
                        </tbody>
                    </table> : <div>No data available</div>}

                </div>
                <div className="table-footer-content"></div>
            </div>
        </div>
    )
}
